<template>
  <header class="app-header">
    <a class="app-header__logo" href="index.html">
  <svg class="header-logo3"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 40" width="400" height="40">
    <text x="0" y="50" font-family="Arial, sans-serif" font-size="48" fill="orange" font-weight="bold" class="animated-text">
      ASLAN ENERGY
    
    </text>
  </svg>
</a>
    <!-- Sidebar toggle button-->
    <a
      class="app-sidebar__toggle"
      href="#"
      data-toggle="sidebar"
      aria-label="Hide Sidebar"
    ></a>
    <!-- Navbar Right Menu-->
    <ul class="app-nav">
      <!-- User Menu-->

      <li class="dropdown">
        <a
          class="app-nav__item"
          href="#"
          data-toggle="dropdown"
          aria-label="Open Profile Menu"
          ><i class="fa fa-user fa-lg"></i
        ></a>
        <ul class="dropdown-menu settings-menu dropdown-menu-right">
          <li>
            <router-link
              v-if="token"
              class="dropdown-item refresh"
              to="/personalsettings"
              tag="a"
            >
              <i class="fa fa-user fa-lg"></i>
              <span class="app-menu__label">Profil Ayarları</span>
            </router-link>
          </li>
          <li>
            <router-link
              v-if="id != 2"
              class="dropdown-item refresh"
              to="/adminpersonalsettings"
              tag="a"
            >
              <i class="fa fa-user fa-lg"></i>
              <span class="app-menu__label">Admin Ayarları</span>
            </router-link>
          </li>
          <li>
            <a @click.prevent="logout" class="dropdown-item" href="#"
              ><i class="fa fa-sign-out fa-lg"></i> Çıkış</a
            >
          </li>
        </ul>
      </li>
    </ul>
  </header>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      admin_token: "",
      token: "",
    };
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
    },
  },
  mounted() {
    this.token = localStorage.getItem("token");
    this.admin_token = localStorage.getItem("admin_token");
    this.id = localStorage.getItem("id");

  },
};
</script>



// WEBPACK FOOTER //
// src/components/default/Header.vue